import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { ButtonList } from 'components/Button';

const ActionBar = ({ children, sideAction, type, className, ...props }) => {
  return (
    <div className={cx("g-action-bar", type, className)} {...props}>
      <ButtonList>
        {children}
      </ButtonList>
      { sideAction && 
      <div className="action-side">{sideAction}</div>}
    </div>
  );
}

export default ActionBar;